import { CalibrationMeasurementSet } from "../../API/calibration";

export function sourceResultSetIdOf(resultSet: {
  id: string;
  calibration?: { source_result_set_id: string } | null;
}): string {
  return resultSet.calibration?.source_result_set_id ?? resultSet.id;
}

export function latestMeasurementSet(
  measurementSets: CalibrationMeasurementSet[],
): CalibrationMeasurementSet | undefined {
  return [...measurementSets].sort(
    (a, b) => b.version - a.version || b.created_at.localeCompare(a.created_at),
  )[0];
}
